export default __webpack_public_path__ + "static/media/solution-test-materials.0e028aec.png";